import * as types from './actionTypes';  
import sixtyminuteEmailApi from '../api/sixtyminuteEmailApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function doSendSixtyMinuteEmail(ext_id) {

  return {
    type: types.DO_SEND_SIXTY_MINUTE_EMAIL, 
    ext_id
  };
}

export function doSendSixtyMinuteEmailRes(data) {  
  return {
    type: types.DO_SEND_SIXTY_MINUTE_EMAIL_RES, 
    data
  };
}

export function sendSixtyMinuteEmail(ext_id) {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      sixtyminuteEmailApi.doSendSixtyMinuteEmail(ext_id).then(data => {
        dispatch(doSendSixtyMinuteEmailRes(data));
        dispatch(doSendSixtyMinuteEmailRes(null));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
  
}